import React, { createContext, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import { useScheduleTaggingActions } from "./hooks/useScheduleTaggingActions";

export const ScheduleTaggingContext = createContext(null);

// One provider per tax computation; consumers do not depend on Console props.
export default function ScheduleTaggingProvider({
  company,
  onSchedulesChanged,
  children,
}) {
  const {
    addAutoloadData,
    deleteAutoloadData,
    createPLSchedule,
    createCASchedule,
    getSchedules,
    getCAScheduleList,
  } = useContext(AuthContext);
  const onSuccess = useSuccessDialog();
  const onError = useErrorDialog();
  const actions = useScheduleTaggingActions({
    tcId: company.tc_id,
    companyType: company.companyType,
    addAutoloadData,
    deleteAutoloadData,
    createPLSchedule,
    createCASchedule,
    onSuccess,
    onError,
    onSchedulesChanged,
  });
  const value = useMemo(
    () => ({
      ...actions,
      getPlScheduleByType: getSchedules,
      getCaScheduleByType: getCAScheduleList,
    }),
    [actions, getSchedules, getCAScheduleList]
  );

  return (
    <ScheduleTaggingContext.Provider value={value}>
      {children}
    </ScheduleTaggingContext.Provider>
  );
}
